// Loads the chosen look (a whole stylesheet from /styles) and the light/dark choice, for both the app and the login page.
// The page starts hidden (style="visibility:hidden" on <html>) so it never shows unstyled.

export const STYLE_NAMES: Record<string, string> = {
  blueprint: "Blueprint", modern: "Modern", editorial: "Editorial", terminal: "Terminal", retro: "Retro", pacman: "Pac-Man",
};

export function savedStyle(): string | null {
  try {
    const s = localStorage.getItem("qb.style");
    return s && s in STYLE_NAMES ? s : null;
  } catch { return null; }
}

let current: HTMLLinkElement | null = null;
const reveal = () => document.documentElement.style.removeProperty("visibility");

/** Swaps the stylesheet; the old one stays until the new one has loaded, so nothing flashes. */
export function loadStyle(style = savedStyle() ?? "default") {
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = `/styles/${style}.css`;
  const old = current;
  // "qb:style" tells the page the look has changed, so it can re-measure anything sized to its text
  const done = () => { old?.remove(); reveal(); window.dispatchEvent(new Event("qb:style")); };
  link.addEventListener("load", done, { once: true });
  link.addEventListener("error", done, { once: true });
  document.head.append(link);
  current = link;
}

export function setStyle(style: string) {
  try { localStorage.setItem("qb.style", style); } catch {}
  loadStyle(style);
}

try {
  const t = localStorage.getItem("qb.theme");
  if (t === "light" || t === "dark") document.documentElement.dataset.theme = t;
} catch {}
loadStyle();
setTimeout(reveal, 2500); // never stay hidden, even if the stylesheet can't load
